(ns web3.tracking.components
  (:require [re-frame-simple.db :as db]
            [web3.tracking.ga :as ga]
            [web3.tracking.segment :as seg]
            [web3.log :as log]
            [web3.view :as v]))

(defn assoc-in-context!
  [e-k e]
  (db/assoc-in! [::event-context e-k] e))

(defn dissoc-from-context!
  [context-key]
  (let [context (db/get ::event-context)
        new-context (dissoc context context-key)]
   (db/assoc! ::event-context new-context)))


(defn a
  [props & children]
  (into
   [:a (v/merge-props props {:on-click #(do (seg/event! "Exit Link" {:href (:href props)})
                                            (ga/event! "click"
                                                       {:event_category "outbound"
                                                        :event_label (:href props)
                                                        :transport_type "beacon"})
                                            false)})]
   children))

